<template>
  <PgDialogForm
    v-if="dialogProps"
    ref="formRef"
    :visible="visible"
    v-bind="dialogProps"
    @close="btnClick()"
    @closed="closed"
  >
    <template #footer="{ formData }">
      <Button
        round
        size="medium"
        style="min-width: 120px"
        :loading="cacelLoading"
        @click="btnClick(formData)"
        v-if="props.cacelText"
        >{{ props.cacelText }}</Button
      >
      <Button
        :type="props.secoundConfirmType"
        round
        style="min-width: 120px"
        size="medium"
        :loading="secoundConfirmLoading"
        @click="btnClick(formData, 'secoundConfirm')"
        v-if="props.secoundConfirmText"
        >{{ props.secoundConfirmText }}</Button
      >
      <Button
        type="primary"
        round
        style="min-width: 120px"
        size="medium"
        :loading="confirmLoading"
        @click="btnClick(formData, 'confirm')"
        v-if="props.confirmText"
        >{{ props.confirmText }}</Button
      >
    </template>
  </PgDialogForm>
</template>
<script setup>
import PgDialogForm from './dialog-form.vue'
import { reactive, shallowRef, ref, getCurrentInstance } from 'vue'
import { Button } from 'element-ui'

const props = reactive({
  cacelText: '取 消',
  secoundConfirmText: null,
  secoundConfirmType: 'primary',
  confirmText: '确 认',
  beforeClose: null, //非配置项
  close: null, //非配置项
})

const { proxy } = getCurrentInstance()
//关闭动画完成之后的回调
const closed = () => {
  props.close?.()
  proxy.$destroy(true)
  // proxy.$el.parentNode.removeChild(proxy.$el)
}

const visible = ref(true)
const dialogProps = shallowRef(null)
const cacelLoading = ref(false)
const secoundConfirmLoading = ref(false)
const confirmLoading = ref(false)
//关闭方法
const onClose = () => {
  visible.value = false
  cacelLoading.value = false
  secoundConfirmLoading.value = false
  confirmLoading.value = false
}
//按钮事件
const formRef = ref(null)
const btnClick = async (dialogData, type) => {
  if (type === 'secoundConfirm' || type === 'confirm') {
    const error = await formRef.value.validate()
    if (error) return
  }
  if (type === 'secoundConfirm') {
    secoundConfirmLoading.value = true
  } else if (type === 'confirm') {
    confirmLoading.value = true
  } else {
    cacelLoading.value = true
  }

  props.beforeClose({ dialogData, onClose, type })
}
const show = (options) => {
  const {
    cacelText,
    secoundConfirmText,
    secoundConfirmType,
    confirmText,
    beforeClose,
    close,
    ...tempDialogProps
  } = options
  props.cacelText = cacelText ?? props.cacelText
  props.secoundConfirmText = secoundConfirmText ?? props.secoundConfirmText
  props.secoundConfirmType = secoundConfirmType ?? props.secoundConfirmType
  props.confirmText = confirmText ?? props.confirmText
  props.beforeClose = beforeClose
  props.close = close
  dialogProps.value = tempDialogProps
}

defineExpose({
  show,
  setProps(key, val) {
    props[key] = val
  },
  setAllLoading(val = false) {
    secoundConfirmLoading.value = val
    confirmLoading.value = val
    cacelLoading.value = val
  },
})
</script>
